import React, { useContext } from "react"
import { Text, TouchableOpacity, View } from "react-native"
import { ThemeContext } from "../../context/ThemeContext"
import { textStyles } from "../../../style"
import { Ionicons } from "@expo/vector-icons"
import Haptics from "../../haptics"

type CheckBoxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  showInactiveLabel?: boolean;
  disabled?: boolean;
}

export const ThemedCheckBox:React.FC<CheckBoxProps> = (props: CheckBoxProps) => {
  const theme = useContext(ThemeContext)
  const { primary, textMain, placeholder } = theme.theme.colors

  return (
    <TouchableOpacity onPress={() => {
        Haptics.selection()
        props.onChange(!props.checked)
      }}
      disabled={props.disabled}
    >
      <View style={{flexDirection: "row", alignItems: "center", gap: 10}}>
        <Ionicons name={props.checked ? "checkbox" : "square-outline"} size={24} color={props.checked ? primary : placeholder} />
        <Text 
          style={[
            textStyles.body,
            {
              color: props.showInactiveLabel && !props.checked ? placeholder : textMain,
              flex: 1
            }
          ]}
        >
          {props.label}
        </Text>
      </View>
    </TouchableOpacity>
  )
}